import React from 'react';

import SessionApi from '@opendoor/shared-fe/api/session';

import { COOKIE_KEY, WEB_API_URL } from '../helpers/globals';

export const Sessions = new SessionApi(COOKIE_KEY, WEB_API_URL);
export const SessionContext = React.createContext<SessionApi>(Sessions);
